import React from "react";

const Quote = ({ block, last }) => {

  const quoteClass = block.style === "pullquote" ? "leading-none relative border-none not-italic" : "text-lg border-l border-gray-700 pl-4 py-2 text-gray-700 flex flex-col text-bold";
 
  return (
    <section>
      <div className="shell">
        <div className={`prose max-w-none clear-both${!last ? " mb-7" : ""}`}>
          <blockquote className={`${quoteClass}`} style={{ quotes: block.style === "pullquote" ? "none" : "initial", }}>
            <div className={`relative${block.style === "pullquote" ? " sm:pl-9 pt-11" : ""}`}>
              <div className="lg:text-2xl leading-relaxed font-thin mt-firstchild-0" dangerouslySetInnerHTML={{__html: block.quote,}}/>
              {block.attribution && (
                <footer className={`text-gray-600 font-sans text-base  ${block.style === "blockqoute" ? "text-gray-600 font-sans text-base" : "text-gray-600 uppercase text-lg not-italic font-normal tracking-wider"}`}>&mdash; {block.attribution}</footer>
              )}
            </div>
          </blockquote>
        </div>
      </div>
    </section>
  );
}

export default Quote;